import {
  ADD_NEW_MERCHANT_GROUP_FAIL,
  ADD_NEW_MERCHANT_GROUP_SUCCESS,
  GET_MERCHANT_GROUP_FAIL,
  GET_MERCHANT_GROUP_SUCCESS,
  CLEAR_MERCHANT_GROUP,
  UPLOAD_BASE64_FILE_FAIL,
  UPLOAD_BASE64_FILE_SUCCESS,
  GET_MERCHANT_GROUP_DETAIL_SUCCESS,
  GET_MERCHANT_GROUP_DETAIL_FAIL,
  CLEAR_MERCHANT_GROUP_DETAIL,
  GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL,
  CLEAR_MERCHANT_GROUP_COMMUNICATIONS,
  MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL,
  GET_MERCHANT_GROUP_CONTACTS,
  GET_MERCHANT_GROUP_CONTACTS_SUCCESS,
  GET_MERCHANT_GROUP_CONTACTS_FAIL,
  CLEAR_MERCHANT_GROUP_CONTACTS,
  MANAGE_MERCHANT_GROUP_CONTACT,
  MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS,
  MANAGE_MERCHANT_GROUP_CONTACT_FAIL,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS,
  GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS,
  MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL,
  GET_MERCHANT_GROUP_BANKING,
  GET_MERCHANT_GROUP_BANKING_SUCCESS,
  GET_MERCHANT_GROUP_BANKING_FAIL,
  CLEAR_MERCHANT_GROUP_BANKING,
  GET_MERCHANT_GROUP_BANKING_DETAIL,
  GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS,
  GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL,
  CLEAR_MERCHANT_GROUP_BANKING_DETAIL,
  ADD_NEW_MERCHANT_GROUP_BANKING,
  ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS,
  ADD_NEW_MERCHANT_GROUP_BANKING_FAIL,
  MANAGE_MERCHANT_GROUP_BANKING,
  MANAGE_MERCHANT_GROUP_BANKING_SUCCESS,
  MANAGE_MERCHANT_GROUP_BANKING_FAIL,
  CHECK_MERCHANT_GROUP_BANKING_STATUS,
  CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS,
  CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL,
  SET_CONTACT_CREATION_STATE,
  CLEAR_CONTACT_CREATION_STATE,
  DELETE_MERCHANT_GROUP,
  DELETE_MERCHANT_GROUP_SUCCESS,
  DELETE_MERCHANT_GROUP_FAIL,
  GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  GET_MERCHANT_GROUP_ADMIN_USER_FAIL,
  CLEAR_MERCHANT_GROUP_ADMIN_USER,
  CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS,
  CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  merchantGroups: [],
  merchantGroupDetail: null,
  error: {},
  deleteError: null,
  merchantGroupLogo: [],
  merchantGroupCommunications: [],
  communicationError: null,
  creationSuccess: null,

  merchantGroupContacts: [],
  contactError: null,
  isLoadingContacts: false,
  merchantGroupContactCommunications: [],
  contactCommunicationError: null,
  isLoadingContactCommunications: false,
  
  merchantGroupBanking: null,
  merchantGroupBankingList: [],
  bankingError: null,
  isLoadingBanking: false,
  bankingCreationSuccess: false,
  
  contactCreationState: {
    phase: "contact", // "contact" or "communication"
    currentContact: null,
    isContactReadOnly: false,
  },
  
  // Admin User
  merchantGroupAdminUser: null,
  adminUserError: null,
  adminUserCreationSuccess: false,
}

const merchantGroup = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MERCHANT_GROUP_SUCCESS:
      return {
        ...state,
        merchantGroups: action.payload,
        error: {},
      }

    case GET_MERCHANT_GROUP_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_MERCHANT_GROUP:
      return {
        ...state,
        merchantGroups: [],
        error: {},
      }

    case ADD_NEW_MERCHANT_GROUP_SUCCESS:
      return {
        ...state,
        error: {},
        creationSuccess: action.payload,
      }

    case ADD_NEW_MERCHANT_GROUP_FAIL:
      return {
        ...state,
        error: action.payload,
        creationSuccess: null,
      }


    //uploadBase64File
    case UPLOAD_BASE64_FILE_SUCCESS:
      return {
        ...state,
        merchantGroupLogo: [action.payload, ...state.merchantGroups],
      }

    case UPLOAD_BASE64_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MERCHANT_GROUP_DETAIL_SUCCESS:
      return {
        ...state,
        merchantGroupDetail: action.payload,
        error: {},
      }

    case GET_MERCHANT_GROUP_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CLEAR_MERCHANT_GROUP_DETAIL:
      return {
        ...state,
        merchantGroupDetail: null,
        error: {},
        creationSuccess: null,
      }
    case GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        merchantGroupCommunications: action.payload,
        communicationError: null,
      }

    case GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL:
      return {
        ...state,
        communicationError: action.payload,
      }

    case CLEAR_MERCHANT_GROUP_COMMUNICATIONS:
      return {
        ...state,
        merchantGroupCommunications: [],
        communicationError: null,
      }

    case MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS:
      return {
        ...state,
        communicationError: null,
      }

    case MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL:
      return {
        ...state,
        communicationError: action.payload,
      }


    // Merchant Group Contacts
    case GET_MERCHANT_GROUP_CONTACTS:
      return {
        ...state,
        isLoadingContacts: true,
      }

    case GET_MERCHANT_GROUP_CONTACTS_SUCCESS:
      return {
        ...state,
        merchantGroupContacts: action.payload,
        contactError: null,
        isLoadingContacts: false,
      }

    case GET_MERCHANT_GROUP_CONTACTS_FAIL:
      return {
        ...state,
        contactError: action.payload,
        isLoadingContacts: false,
      }

    case CLEAR_MERCHANT_GROUP_CONTACTS:
      return {
        ...state,
        merchantGroupContacts: [],
        contactError: null,
        isLoadingContacts: false,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT:
      return {
        ...state,
        isLoadingContacts: true,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS:
      return {
        ...state,
        contactError: null,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT_FAIL:
      return {
        ...state,
        contactError: action.payload,
        isLoadingContacts: false,
      }

    // Merchant Group Contact Communications
    case GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS:
      return {
        ...state,
        isLoadingContactCommunications: true,
      }

    case GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        merchantGroupContactCommunications: action.payload,
        contactCommunicationError: null,
        isLoadingContactCommunications: false,
      }

    case GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL:
      return {
        ...state,
        contactCommunicationError: action.payload,
        isLoadingContactCommunications: false,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION:
      return {
        ...state,
        isLoadingContactCommunications: true,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS:
      return {
        ...state,
        contactCommunicationError: null,
      }

    case MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL:
      return {
        ...state,
        contactCommunicationError: action.payload,
        isLoadingContactCommunications: false,
      }

    // Merchant Group Banking
    case GET_MERCHANT_GROUP_BANKING:
      return {
        ...state,
        isLoadingBanking: true,
      }

    case GET_MERCHANT_GROUP_BANKING_SUCCESS:
      return {
        ...state,
        merchantGroupBanking: action.payload,
        bankingError: null,
        isLoadingBanking: false,
      }

    case GET_MERCHANT_GROUP_BANKING_FAIL:
      return {
        ...state,
        bankingError: action.payload,
        isLoadingBanking: false,
      }

    case MANAGE_MERCHANT_GROUP_BANKING:
      return {
        ...state,
        isLoadingBanking: true,
      }

    case MANAGE_MERCHANT_GROUP_BANKING_SUCCESS:
      return {
        ...state,
        merchantGroupBanking: action.payload,
        // Update the banking list if it exists
        merchantGroupBankingList: state.merchantGroupBankingList.map(banking =>
          banking.merchantGroupBankingID === action.payload.merchantGroupBankingID
            ? action.payload
            : banking
        ),
        bankingError: null,
        isLoadingBanking: false,
      }

    case MANAGE_MERCHANT_GROUP_BANKING_FAIL:
      return {
        ...state,
        bankingError: action.payload,
        isLoadingBanking: false,
      }

    // Check Merchant Group Banking Status
    case CHECK_MERCHANT_GROUP_BANKING_STATUS:
      return {
        ...state,
        bankingError: null,
      }

    case CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS:
      return {
        ...state,
        merchantGroupBankingList: state.merchantGroupBankingList.map(banking =>
          banking.payoutProviderDestinationID === action.payload.destinationID
            ? { ...banking, payoutProviderDestinationStatus: action.payload.status }
            : banking
        ),
        bankingError: null,
      }

    case CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL:
      return {
        ...state,
        bankingError: action.payload,
      }

    // Banking Detail (List) Cases
    case GET_MERCHANT_GROUP_BANKING_DETAIL:
      return {
        ...state,
        isLoadingBanking: true,
        bankingError: null,
      }

    case GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS:
      return {
        ...state,
        merchantGroupBankingList: action.payload || [],
        bankingError: null,
        isLoadingBanking: false,
      }

    case GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL:
      return {
        ...state,
        bankingError: action.payload,
        isLoadingBanking: false,
      }

    case CLEAR_MERCHANT_GROUP_BANKING_DETAIL:
      return {
        ...state,
        merchantGroupBankingList: [],
        bankingError: null,
        isLoadingBanking: false,
      }

    // Add New Banking Cases
    case ADD_NEW_MERCHANT_GROUP_BANKING:
      return {
        ...state,
        isLoadingBanking: true,
        bankingError: null,
        bankingCreationSuccess: false,
      }

    case ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS:
      return {
        ...state,
        merchantGroupBankingList: [...state.merchantGroupBankingList, action.payload],
        bankingError: null,
        isLoadingBanking: false,
        bankingCreationSuccess: true,
      }

    case ADD_NEW_MERCHANT_GROUP_BANKING_FAIL:
      return {
        ...state,
        bankingError: action.payload,
        isLoadingBanking: false,
        bankingCreationSuccess: false,
      }

    case CLEAR_MERCHANT_GROUP_BANKING:
      return {
        ...state,
        merchantGroupBanking: null,
        merchantGroupBankingList: [],
        bankingError: null,
        isLoadingBanking: false,
        bankingCreationSuccess: false,
      }

    case SET_CONTACT_CREATION_STATE:
      return {
        ...state,
        contactCreationState: {
          ...state.contactCreationState,
          ...action.payload,
        },
      }

    case CLEAR_CONTACT_CREATION_STATE:
      return {
        ...state,
        contactCreationState: {
          phase: "contact",
          currentContact: null,
          isContactReadOnly: false,
        },
      }

    // Delete Merchant Group
    case DELETE_MERCHANT_GROUP:
      return {
        ...state,
        deleteError: null,
      }

    case DELETE_MERCHANT_GROUP_SUCCESS:
      return {
        ...state,
        deleteError: null,
      }

    case DELETE_MERCHANT_GROUP_FAIL:
      return {
        ...state,
        deleteError: action.payload,
      }

    // Merchant Group Admin User
    case GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS:
      return {
        ...state,
        merchantGroupAdminUser: action.payload,
        adminUserError: null,
      }

    case GET_MERCHANT_GROUP_ADMIN_USER_FAIL:
      return {
        ...state,
        adminUserError: action.payload,
      }

    case CLEAR_MERCHANT_GROUP_ADMIN_USER:
      return {
        ...state,
        merchantGroupAdminUser: null,
        adminUserError: null,
        adminUserCreationSuccess: false,
      }

    case CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS:
      return {
        ...state,
        merchantGroupAdminUser: action.payload,
        adminUserError: null,
        adminUserCreationSuccess: true,
      }

    case CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL:
      return {
        ...state,
        adminUserError: action.payload,
        adminUserCreationSuccess: false,
      }

    default:
      return { ...state }
  }
}

export default merchantGroup
